import { useEffect } from "react";

import { useAppSelector } from "@/store/hooks";

/**
 * Syncs the Redux `theme` preference to the <html> `class` attribute.
 * Tailwind's `darkMode: "class"` strategy reads this.
 *
 * Render this once inside <Providers>, above the router.
 */
export function ThemeSync() {
  const theme = useAppSelector((s) => s.user.theme);

  useEffect(() => {
    const root = document.documentElement;
    const prefersDark = window.matchMedia(
      "(prefers-color-scheme: dark)",
    ).matches;

    const isDark =
      theme === "dark" || (theme === "system" && prefersDark);

    root.classList.toggle("dark", isDark);
  }, [theme]);

  // Also listen to system preference changes when theme === 'system'
  useEffect(() => {
    if (theme !== "system") return;

    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const handler = (e: MediaQueryListEvent) => {
      document.documentElement.classList.toggle("dark", e.matches);
    };

    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, [theme]);

  return null;
}